module.exports = __webpack_public_path__ + "img/248444524_2944318595897129_108530650824977335_n.c7e34773.jpg";